/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  Deletable,
  DeletableOptional,
  DeletableMetaI,
  DeletableTrackedI,
} from "./deletable";
import { DeletableTracked, DeletableMeta } from "./deletable";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonRef,
  PersonRefOptional,
  PersonRefMetaI,
  PersonRefTrackedI,
} from "./person-ref";
import { PersonRefTracked, PersonRefMeta } from "./person-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonSubscriptionBase,
  PersonSubscriptionBaseOptional,
  PersonSubscriptionBaseMetaI,
  PersonSubscriptionBaseTrackedI,
} from "./person-subscription-base";
import {
  PersonSubscriptionBaseTracked,
  PersonSubscriptionBaseMeta,
} from "./person-subscription-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonSubscriptionRef,
  PersonSubscriptionRefOptional,
  PersonSubscriptionRefMetaI,
  PersonSubscriptionRefTrackedI,
} from "./person-subscription-ref";
import {
  PersonSubscriptionRefTracked,
  PersonSubscriptionRefMeta,
} from "./person-subscription-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  WithPersonRef,
  WithPersonRefOptional,
  WithPersonRefMetaI,
  WithPersonRefTrackedI,
} from "./with-person-ref";
import { WithPersonRefTracked, WithPersonRefMeta } from "./with-person-ref";

/**
 *
 * @export
 * @interface PersonSubscriptionFull
 */
export interface PersonSubscriptionFullOptional extends DeletableOptional {
  /**
   *
   * @type {boolean}
   * @memberof PersonSubscriptionFull
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonSubscriptionFull
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof PersonSubscriptionFull
   */
  assignId?: number;
  /**
   *
   * @type {string}
   * @memberof PersonSubscriptionFull
   */
  billingDate?: Date;
  /**
   *
   * @type {string}
   * @memberof PersonSubscriptionFull
   */
  billingCycle?: string;
  /**
   *
   * @type {PersonRef}
   * @memberof PersonSubscriptionFull
   */
  personId?: PersonRefOptional;
}

export interface PersonSubscriptionFull
  extends
    PersonSubscriptionFullOptional,
    Deletable,
    PersonSubscriptionBase,
    PersonSubscriptionRef,
    WithPersonRef {
  /**
   *
   * @type {boolean}
   * @memberof PersonSubscriptionFull
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonSubscriptionFull
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof PersonSubscriptionFull
   */
  assignId: number;
  /**
   *
   * @type {string}
   * @memberof PersonSubscriptionFull
   */
  billingDate?: Date;
  /**
   *
   * @type {string}
   * @memberof PersonSubscriptionFull
   */
  billingCycle: string;
  /**
   *
   * @type {PersonRef}
   * @memberof PersonSubscriptionFull
   */
  personId: PersonRef;
}

export interface PersonSubscriptionFullTrackedI extends DeletableOptional {
  /**
   *
   * @type {boolean}
   * @memberof PersonSubscriptionFull
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonSubscriptionFull
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof PersonSubscriptionFull
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonSubscriptionFull
   */
  billingDate?: Date;
  billingDateIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonSubscriptionFull
   */
  billingCycle?: string;
  billingCycleIsSet: boolean;
  /**
   *
   * @type {PersonRef}
   * @memberof PersonSubscriptionFull
   */
  personId?: PersonRefTrackedI;
  personIdIsSet: boolean;
}

transformDatesMap.set(
  "PersonSubscriptionFull",
  function (model: PersonSubscriptionFull) {
    if (typeof model.billingDate == "string")
      model.billingDate = new Date(model.billingDate);
    const transformDatespersonId = transformDatesMap.get("PersonRef");
    if (transformDatespersonId && model.personId) {
      transformDatespersonId(model.personId);
    }
  },
);

export type PersonSubscriptionFullMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: true
  //isDatetime: false
  billingDate: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  billingCycle: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  personId: PropertyMeta<PersonRefMetaI>;
}>;

export var PersonSubscriptionFullMeta: PersonSubscriptionFullMetaI =
  {} as PersonSubscriptionFullMetaI;
PersonSubscriptionFullMeta = typeMeta("PersonSubscriptionFull", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  billingDate: propertyMeta(
    "billingDate",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  billingCycle: propertyMeta(
    "billingCycle",
    false,
    true,
    false,
    MetaTypesBase.string,
  ),
  personId: propertyMeta("personId", false, true, false, PersonRefMeta),
});

const metaI = PersonSubscriptionFullMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([DeletableMeta]);
  metaI.isDeleted.inheritedFrom = DeletableMeta.isDeleted;
  metaI.isNew.inheritedFrom = DeletableMeta.isNew;
  metaI.interfaces = metaI.interfaces.concat([PersonSubscriptionRefMeta]);
  metaI.assignId.inheritedFrom = PersonSubscriptionRefMeta.assignId;
  metaI.interfaces = metaI.interfaces.concat([PersonSubscriptionBaseMeta]);
  metaI.assignId.inheritedFrom = PersonSubscriptionBaseMeta.assignId;
  metaI.billingDate.inheritedFrom = PersonSubscriptionBaseMeta.billingDate;
  metaI.billingCycle.inheritedFrom = PersonSubscriptionBaseMeta.billingCycle;
  metaI.interfaces = metaI.interfaces.concat([WithPersonRefMeta]);
  metaI.personId.inheritedFrom = WithPersonRefMeta.personId;
});

export class PersonSubscriptionFullTracked
  extends DeletableTracked
  implements PersonSubscriptionFullTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  billingDate__I?: Date = undefined;
  billingDateIsSet: boolean = false;
  set billingDate(v: undefined | Date) {
    if (v !== undefined) {
      this.billingDate__I = v;
      this.billingDateIsSet = true;
    } else {
      this.billingDate__I = v || undefined;
      this.billingDateIsSet = false;
    }
    this.changeTracker = true;
  }
  get billingDate() {
    return this.billingDate__I;
  }
  billingCycle__I?: string = undefined;
  billingCycleIsSet: boolean = false;
  set billingCycle(v: undefined | string) {
    if (v !== undefined) {
      this.billingCycle__I = v;
      this.billingCycleIsSet = true;
    } else {
      this.billingCycle__I = v || undefined;
      this.billingCycleIsSet = true;
    }
    this.changeTracker = true;
  }
  get billingCycle() {
    return this.billingCycle__I;
  }
  personId__I?: PersonRefTracked = undefined;
  personIdIsSet: boolean = false;
  set personId(v: undefined | PersonRefTracked) {
    if (v !== undefined) {
      this.personId__I = v;
      this.personIdIsSet = true;
    } else {
      this.personId__I = v || undefined;
      this.personIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get personId() {
    return this.personId__I;
  }
  constructor(
    config?: PersonSubscriptionFullOptional,
    options?: AssignOptions,
  ) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.personId?.setIds();
  }
  assignFrom(
    config: PersonSubscriptionFullOptional,
    options?: AssignOptions,
  ): PersonSubscriptionFullTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (
      config.billingDate &&
      this.billingDateApplyFilter(optionsRequired.filter)
    ) {
      this.billingDate = config.billingDate;
      if (optionsRequired.unassign) this.billingDateIsSet = false;
      else this.billingDateIsSet = true;
    }
    if (
      config.billingCycle &&
      this.billingCycleApplyFilter(optionsRequired.filter)
    ) {
      this.billingCycle = config.billingCycle;
      if (optionsRequired.unassign) this.billingCycleIsSet = false;
      else this.billingCycleIsSet = true;
    }
    if (config.personId && this.personIdApplyFilter(optionsRequired.filter)) {
      this.personId = new PersonRefTracked(config.personId, options);
      if (optionsRequired.unassign) this.personIdIsSet = false;
      else this.personIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PersonSubscriptionFullTrackedI {
    const cloned = {} as PersonSubscriptionFullTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.billingDateIsSetDeep() &&
      this.billingDateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.billingDateIsSet = true;
      cloned.billingDate = this.billingDate;
    } else {
      //cloned.billingDateIsSet = false
    }
    if (
      this.billingCycleIsSetDeep() &&
      this.billingCycleApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.billingCycleIsSet = true;
      cloned.billingCycle = this.billingCycle;
    } else {
      //cloned.billingCycleIsSet = false
    }
    if (
      this.personIdIsSetDeep() &&
      this.personIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.personIdIsSet = true;
      cloned.personId = this.personId?.removeUnset(filter);
    } else {
      //cloned.personIdIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PersonSubscriptionFullTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.billingDateApplyFilter(filter)) this.billingDateIsSet = false;

    if (!this.billingCycleApplyFilter(filter)) this.billingCycleIsSet = false;

    if (!this.personIdApplyFilter(filter)) this.personIdIsSet = false;
    this.personId?.unassignAll(filter);

    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonSubscriptionFullMeta.isDeleted,
      PersonSubscriptionFullMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonSubscriptionFullMeta.isNew,
      PersonSubscriptionFullMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonSubscriptionFullMeta.assignId,
      PersonSubscriptionFullMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  billingDateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonSubscriptionFullMeta.billingDate,
      PersonSubscriptionFullMeta,
      this.billingDate,
      this,
    );
  }
  billingDateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.billingDateIsSet && this.billingDateApplyFilter(filter))
      return true;

    return false;
  }
  billingCycleApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonSubscriptionFullMeta.billingCycle,
      PersonSubscriptionFullMeta,
      this.billingCycle,
      this,
    );
  }
  billingCycleIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.billingCycleIsSet && this.billingCycleApplyFilter(filter))
      return true;

    return false;
  }
  personIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonSubscriptionFullMeta.personId,
      PersonSubscriptionFullMeta,
      this.personId,
      this,
    );
  }
  personIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.personIdIsSet && this.personIdApplyFilter(filter)) return true;
    return this.personId?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.billingDateIsSetDeep(filter)) return true;
    if (this.billingCycleIsSetDeep(filter)) return true;
    if (this.personIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
